export default "__VITE_ASSET__BRO2dm4N__"